
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/linkpoints/cards",
      function () {
        return require("private-next-pages/linkpoints/cards.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/linkpoints/cards"])
      });
    }
  